import React from "react";
import {AlertBottom} from "@vedmarket/ui-kit";

import styles from './Contacts.module.scss';
import {COLORS} from "../../../../../config/constants";
import {typografText} from "../../utils/typograf";
import ContactForm from "./components/ContactForm";
import H1 from "../../components/typography/H1";
import H4 from "../../components/typography/H4";
import LI1 from "../../components/typography/LI1";
import List1 from "../../components/typography/List1";
import P1 from "../../components/typography/P1";

const SuccessScreen = () => {
    return (
        <div className={styles.successScreen}>
            <div className={styles.successEmoji}>{typografText('🕊️')}</div>
            <div className={styles.successText}>
                <H4 sx={{
                    color: COLORS.BLACK,
                    transform: 'translateY(4px)',
                    '@media (min-width: 1200px)': {
                        transform: 'translateY(5px)',
                    },
                    '@media (min-width: 576px) and (max-width: 767px)': {
                        fontFamily: 'Nexa Heavy, Nexa, Roboto, sans-serif',
                        fontWeight: 900,
                        fontSize: '24px',
                        lineHeight: 1.28,
                    },
                }}>Thank you for your request</H4>
                <LI1 sx={{
                    color: COLORS.BLACK,
                    maxWidth: '248px',
                    '@media (max-width: 767px)': {
                        fontSize: '14px',
                        lineHeight: 1.6,
                    },
                    '@media (min-width: 768px) and (max-width: 1199px)': {
                        fontSize: '16px',
                        lineHeight: 1.6,
                        maxWidth: '284px',
                    },
                    '@media (min-width: 1200px)': {
                        fontSize: '18px',
                        lineHeight: 1.6,
                        maxWidth: '320px',
                    },
                }}>
                    We are processing your request and will get back to you soon
                </LI1>
            </div>
        </div>
    );
}

function Contacts() {

    const [isSuccess, setIsSuccess] = React.useState(false);
    const [isError, setIsError] = React.useState(false);

    return (
        <div className={styles.section} id="contacts">
            <div className={styles.sectionContainer}>
                <H1>
                    Get in touch
                </H1>
                <List1 className={styles.subtitle} sx={{
                    '@media (min-width: 1200px)': {
                        marginTop: 0,
                        alignSelf: 'start',
                    },
                    '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                        marginTop: '-24px',
                    },
                    '@media screen and (min-width: 576px) and (max-width: 767px)': {
                        fontSize: '14px',
                        lineHeight: 1.6,
                        marginTop: '-16px',
                    },
                    '@media screen and (max-width: 575px)': {
                        marginTop: '-16px',
                    },
                }}>
                    {typografText('Ready for requests from clients who have already worked out the costs?')}
                </List1>
                <AlertBottom
                    open={isError}
                    isError
                    message={typografText('Please try again')}
                    onClose={() => setIsError(false)}
                />
                {isSuccess ? <SuccessScreen /> :
                    <div className={styles.contactFormContainer}>
                        <ContactForm onSuccess={setIsSuccess} onError={setIsError}/>
                    </div>}
                <P1 className={styles.copyright} sx={{
                    '@media (min-width: 1200px)': {
                        marginTop: '32px',
                    },
                    '@media screen and (min-width: 576px) and (max-width: 767px)': {
                        fontSize: '14px',
                        lineHeight: 1.5,
                    },
                }}>
                    © 2026 Vedmarket
                </P1>
            </div>
        </div>
    );
}

export default Contacts
